
<div :class="jel_getClassObject(content)">
  <span class="lienPrimaire cursor-pointer" @click="isAfficherModale = true">
    {{ content.libBouton }}
  </span>
  <b-modal
    v-model="isAfficherModale"
    :hide-footer="true"
    dialog-class="d-flex align-items-center h-100"
    body-class="compteClair pt-0"
  >
    <template #modal-header>
      <div class="float-right icone-fermer" @click="isAfficherModale = false">
        <svg-icon
          icon-name="icone-fermer-mince"
          color="$couleur-primaire"
          className="iconeFermer"
        />
      </div>
    </template>
    <div class="configuration">
      <div class="info">{{ $t('messageComponent.navigateur') }}</div>
      <div class="resultat p-0">{{ browser }} {{ browserVersion }}</div>
    </div>
    <div class="configuration">
      <div class="info">{{ $t('messageComponent.langue') }}</div>
      <div class="resultat p-0">{{ navigator.language }}</div>
    </div>
    <div class="configuration">
      <div class="info">{{ $t('messageComponent.cookie') }}</div>
      <div class="resultat p-0">
        {{
          navigator.cookieEnabled
            ? $i18n.tc('messageComponent.oui')
            : $i18n.tc('messageComponent.non')
        }}
      </div>
    </div>
    <div class="configuration">
      <div class="info">{{ $t('messageComponent.systeme') }}</div>
      <div class="resultat p-0">{{ navigator.platform }}</div>
    </div>
    <div class="configuration">
      <div class="info">{{ $t('messageComponent.infoTechnique') }}</div>
      <div class="resultat p-0">{{ navigator.userAgent }}</div>
    </div>
  </b-modal>
</div>
